<template>
  <v-container fluid>

  <v-card>

      <v-card-title>

        <span class="headline hidden-xs-only">{{titulo}}</span>
        <v-btn class="ml-1 mr-1 " light ripple  icon="icon" @click.native="pesquisar()">
          <v-icon>refresh</v-icon>
        </v-btn>

        <v-spacer class="hidden-xs-only"></v-spacer>
        <v-text-field
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
          class="mr-1"
          v-model="search"
          v-on:keyup.enter="pesquisar()"></v-text-field>

          <v-btn class="ml-1 mr-1" dark ripple color="primary" icon="icon" @click.native="editar()" v-if="this.selected.length==1" >
            <v-icon>edit</v-icon>
          </v-btn>

          <v-btn class="ml-1" dark ripple color="primary" icon="icon" slot="activator" @click.native="dialog=true" v-if="this.selected.length>0" >
            <v-icon>delete</v-icon>
          </v-btn>

      </v-card-title>
      <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          v-bind:search="search"
          v-model="selected"
          selected-key="id"
          select-all
          :disable-initial-sort="true"
          :pagination.sync="pagination"
          :total-items="total"
          :loading="loading"
          >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
            color="primary"
            hide-details
            v-model="props.selected"></v-checkbox>
          </td>
         <td v-if="props.item.ativa===false" class="name">
           {{props.item.nome }}
          <b class="cert inativo"> <v-icon color="white" title="Inativo">block</v-icon></b></td>
          <td v-else class="name">
              {{props.item.nome }}
         </td>
          <td class="name">{{ props.item.nomeFantasia}}</td>
          <td>{{ props.item.cnpj }}</td>

          <td>
            <v-icon v-if="props.item.assinatura===true" color="grey" title="Assinatura Eletrônica">assignment</v-icon>
            <v-icon v-if="props.item.impressao===true" color="grey" title="Impressão">print</v-icon>
            <v-icon v-if="props.item.qrcode===true" color="grey" title="QRCode">qr_code</v-icon>
            <v-icon v-if="props.item.whatsapp===true" color="grey" title="WhatsApp">tap_and_play</v-icon>
            <v-icon v-if="props.item.removerDocumentoAssinatura===true" color="grey" title="CPF Removido">subtitles_off</v-icon>
          </td>
          
        </template>
    </v-data-table>

      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
            <v-card-title>{{confirm.title}}</v-card-title>
            <v-card-text>{{confirm.contentHtml}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="red--text darken-1" flat="flat" @click.native="dialog = false">{{confirm.cancel}}</v-btn>
            <v-btn class="green--text darken-1" flat="flat" @click.native="excluir()">{{confirm.ok}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-fab-transition>
        <v-btn to="/admin/empresa/new" class="accent"
          dark
          fab
          fixed
          bottom
          left
        >
          <v-icon>add</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-fab-transition>

      <v-snackbar
        :timeout="timeoutAlerta"
        :color="tipoAlerta"
        v-model="snackbar">
        {{ textAlerta }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>


    </v-card>
  </v-container>

</template>

<script>

import axios from 'axios'

export default {
  name: 'empresa',
  data () {
    return {
      pagination: {
        sortBy: 'nome',
        descending: 'asc',
        page: 1,
        rowsPerPage: 10
      },
      acao: 0,
      items: [],
      errors: [],
      total: null,
      titulo: 'Empresas',
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar a(s) empresa(s) selecionada(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      loading: true,
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [
        {
          text: 'RAZÃO SOCIAL',
          align: 'left',
          sortable: true,
          value: 'nome'
        },
        {
          text: 'NOME FANTASIA',
          align: 'left',
          sortable: true,
          value: 'nomeFantasia'
        },
        {
          text: 'CNPJ',
          value: 'cnpj',
          sortable: true,
          align: 'left'
        },
        {
          text: 'PRODUTO',
          align: 'left',
          sortable: true,
          value: ''
        }
      ]
    }
  },
  components: {
  },
  computed: {
  },
  watch: {
    search () {
      this.$store.commit('changeEmpresaQuery', {query: this.search})
    },
    pagination: {
      handler () {
        this.atualizarLista()
      },
      deep: true
    }
  },
  methods: {
    excluir () {
      var self = this
      Object.keys(this.selected).forEach((index) => {
        const empresa = this.selected[index]
        console.log('vai excluir ' + empresa.id)

        axios.delete(`/empresas/${empresa.id}`)
          .then(response => {
            self.atualizarLista()

            self.tipoAlerta = 'success'
            self.textAlerta = 'Empresa excluído com sucesso'
            self.snackbar = true
          })
          .catch(e => {
            self.tipoAlerta = 'error'
            self.textAlerta = 'Erro ao excluir empresa'
            self.snackbar = true

            console.log(e)
          })

        setTimeout(function () {
          self.selected = []
        }, 3000)

        this.dialog = false
      })
    },
    editar () {
      var index = Object.keys(this.selected)[0]
      const empresa = this.selected[index]
      this.$router.push({name: 'EmpresaEdit', params: { id: empresa.id }})
    },
    pesquisar () {
      this.pagination.page = 1
      this.atualizarLista()
    },
    atualizarLista () {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      var offset = (page - 1) * rowsPerPage
      var porPagina = rowsPerPage
      if (rowsPerPage !== -1 && rowsPerPage !== 5 && rowsPerPage !== 10 && rowsPerPage !== 25) {
        porPagina = 10
      }
      let order = 'asc'
      if (!descending) {
        order = 'asc'
      }
      axios.get(`/empresas?sort=${sortBy}&order=${order}&offset=${offset}&max=${porPagina}&q=${this.search}`)
        .then(response => {
          // JSON responses are automatically parsed.
          this.items = response.data.list
          this.total = response.data.total
          this.pagination.totalItems = response.data.total
          if (response.data.porPagina) {
            this.pagination.rowsPerPage = response.data.porPagina
          }
          this.loading = false
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  beforeCreate () {
  },
  // Fetches empresas when the component is created.
  created () {
    this.search = this.$store.state.empresaQuery
    this.atualizarLista()
  }
}
</script>

  

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .name {
   text-transform:  uppercase;
  }
  .inativo {    
    padding: 5px 5px;
    margin-right: 5px;
    border-radius: 5px;
    color: #ffffff
   }
</style>



// WEBPACK FOOTER //
// Empresa.vue?5bbd70bf